import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";
import { formItem } from "../../../LeaguesAndCups/leaguesAndCups.css";

export const removeBanWrapper = style([
  formItem,
  {
    display: "grid",
    gap: vars.space.m,
  },
]);

export const playerListWrapper = style({
  display: "grid",
  gap: vars.space.m,
});

export const playerItemWrapper = style({
  display: "grid",
  gap: vars.space.xs,
});

export const headingStyles = style({
  fontSize: vars.fontSizes.heading.m,
});
